module.exports = __webpack_public_path__ + "static/media/nuvemshop6.9332e313.png";